import $ from 'jquery';
import Parallax from './Parallax';

export default class Hero {
  constructor(element, $quicklinks) {
    this.$element = $(element);
    this.$quicklinks = $quicklinks;
    this.Parallax = this.addParallax();
    this.formatMainHeading();
    this.repositionContent();
    this.ready();
  }

  formatMainHeading() {
    const title = this.$element.find('.title').html();
    const regex = /(.+)(<br>\s?)(.+)/gi;
    const heading = title.replace(regex, '<span class="title">$1</span> <span class="subtitle">$3</span>');
    this.$element.find('.node-header').html(heading);
  }

  addParallax() {
    const $parallax = $('<div class="parallax"></div>');
    // Append our image into the parallax container.
    this.$element.find('.field-image img').appendTo($parallax);
    this.$element.prepend($parallax);
    return new Parallax(this.$element.find('.parallax'));
  }

  repositionContent() {
    // Heading block management.
    const $blockContent = this.$element.find('.view-content');
    const $blockControls = this.$element.find('.block-controls-wrapper');
    $blockContent.addClass('heading').prepend($blockControls);

    // Quicklinks block management.
    const $quickContent = this.$quicklinks.find('.view-content');
    const $quickControls = this.$quicklinks.find('.block-controls-wrapper');
    $quickContent.addClass('quicklinks').prepend($quickControls);

    // Append in the quicklinks.
    $quickContent.insertAfter($blockContent);

    // Cleanup markup.
    this.$element.find('.view').children().unwrap();

    // Remove the unneeded quicklinks block markup.
    this.$quicklinks.remove();
  }

  ready() {
    this.$element.addClass('ready');
  }
}



// WEBPACK FOOTER //
// ./Hero.js